/**
 * Canonical URLs of the CSL Brands properties linked from the marketing site.
 * Kept in one place so a domain change is a single edit.
 */
export const BUILDER_URL = 'https://builder.csl-brands.com/';
